const assetUrl =
  'https://assets.hyperinvento.com/www_imaginext_com/assets/imaginext-assets/images/';

const adminAssetUrl = 'https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/';

export const IMAGE_URLS = {
  closedEye: assetUrl + `closed-eye.svg`,
  openEye: assetUrl + `open-eye.svg`,
  editAccountDark: assetUrl + `edit-account-dark.svg`,
  userIcon: assetUrl + `user-icon.svg`,
  residentLocationDark: assetUrl + `resident-location-dark.svg`,
  myOrderDark: assetUrl + `my-orders-dark.svg`,
  addPlusGreen: assetUrl + `add-plus-green.svg`,
  infoCircleDark: assetUrl + `info-circle-dark.svg`,
  noImagePlaceholder: assetUrl + `no-image-placeholder.svg`,
  supportPersonDark: assetUrl + `support-person-dark.svg`,
  arrowLeftIcon: assetUrl + `arrow-left-icon.svg`,
  trashIconDark: assetUrl + `trash-icon-dark.svg`,
  emptyCartHeroImage: assetUrl + `empty-cart-hero-image.png`,
  offerIconDark: assetUrl + `offer-icon-dark.svg`,
  secureIcon: assetUrl + `secure-icon.svg`,
  offerIconGreen: assetUrl + `offer-icon-green.svg`,
  rightCheckCircle: assetUrl + `right-check-circle.svg`,
  pendingIcon: assetUrl + `pending-icon.svg`,
  failedIcon: assetUrl + `failed-icon.svg`,
  searchMagnifyer: assetUrl + `search-magnifyer.svg`,
  telephoneWhiteIcon: assetUrl + `telephone-white-icon.svg`,
  brandIcon: assetUrl + `brand-icon.svg`,
  genericDealerIcon: assetUrl + `generic-dealer-icon.svg`,
  locationBrandIcon: assetUrl + `location-brand-icon.svg`,
  locationDealerIcon: assetUrl + `location-dealer-icon.svg`,
  closeIconDark: assetUrl + `close-icon-dark.svg`,
  shippingIconB: assetUrl + `shipping-icon-b.svg`,
  telephoneBlackIcon: assetUrl + `telephone-black-icon.svg`,
  offerBlueIcon: assetUrl + `offers-blue-icon.svg`,
  leftNavIcon: assetUrl + `left-nav-icon.svg`,
  rightNavIcon: assetUrl + `right-nav-icon.svg`,
  arrowRightBlack: assetUrl + `arrow-right-black.svg`,
  editPenDark: assetUrl + `edit-pen-dark.svg`,
  removeDark: assetUrl + `remove-dark.svg`,
  loaderTransparentBg: assetUrl + `loader-transparent-bg.gif`,
  trashIcon: assetUrl + `trash.svg`,
  mailBlackIcon: assetUrl + `mail-black-icon.svg`,
  dealerShopIcon: assetUrl + `dealer-shop-icon.svg`,
  telephoneRedIcon: assetUrl + `telephone-red-icon.svg`,
  mailRedIcon: assetUrl + `mail-red-icon.svg`,
  docsDownloadIcon: assetUrl + `docs-download-icon.svg`,
  greenCheck: assetUrl + `green-check.svg`,
  rightArrowCircleDark: assetUrl + `right-arrow-circle-dark.svg`,
  magnifyingIcon: assetUrl + `magnifying-icon.svg`,
  locationIconBlack: assetUrl + `location-icon-black.svg`,
  underMaintainanceHeroImage: assetUrl + `under-maintainance-hero-image.svg`,
  topVector: assetUrl + `top-vector.svg`,
  rightVector: assetUrl + `right-vector.svg`,
  leftVector: assetUrl + `left-vector.svg`,
  shoppingCartIcon: assetUrl + `shopping-cart-icon.svg`,
  leftArrowWhite: assetUrl + `left-arrow-white.png`,
  rightArrowWhite: assetUrl + `right-arrow-white.png`,
  referNEarnIcon: assetUrl + `refer-n-earn-icon.svg`,
  cashPointDark: assetUrl + `cash-point-dark.svg`,
  copyIconLight: assetUrl + `copy-icon-light.svg`,
  shareIconLight: assetUrl + `share-icon-light.svg`,
  whatsappWhiteBgIcon: assetUrl + `whatsapp-white-bg-icon.svg`,
  twitterWhiteBgIcon: assetUrl + `twitter-white-bg-icon.svg`,
  gmailWhiteBgIcon: assetUrl + `gmail-white-bg-icon.svg`,
  gavelIconDark: assetUrl + `gavel-icon.svg`,
  infoBulbDarkIcon: assetUrl + `info-bulb-dark.svg`,
  updateIconDark: assetUrl + `update-icon-dark.svg`,
  topArrowBlackIcon: assetUrl + 'top-arrow-black-icon.svg',
  bottomArrowBlackIcon: assetUrl + 'bottom-arrow-black-icon.svg',
  shippingIcon: assetUrl + 'shipping-icon.svg',
  categoryEmptyState: assetUrl + `categoryImage-1.svg `,
  productEmptyState: assetUrl + `productDynamicEmptyStateMobiles-1.svg`,
  productEmptyStateBlack: assetUrl + `productDynamicEmptyStateDesktop-1.svg `,
  header11CategoryEmptyStateImage: adminAssetUrl + 'header-11-category-empty-state-image.png',
  header11CategoryListEmptyStateImage: adminAssetUrl + 'header-11-category-list-empty-state-image.png',
  closeLineIcon: adminAssetUrl + 'close-line-icon.png',
};
